export default __webpack_public_path__ + "0c7ea6b36147e2abe3eed10accdb88c7.svg";